import { Grid, Typography } from "@material-ui/core";
import React from "react";
import useStyles from "../Styles";
import asu_logo from "../../../assets/asu_logo.png";
import { useHistory } from "react-router";
import { AppRouteURI } from "router/RoleBasedAccess";

const HeaderView = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Grid
      container
      justify="space-between"
      alignItems="center"
      className={classes.header}
    >
      <Grid
        container
        item
        style={{ flex: 1, marginLeft: 24 }}
        alignItems="center"
        onClick={() => history.push(AppRouteURI.HOME)}
      >
        <Typography variant="h5" noWrap href="" className={classes.headerText}>
          AZ CuRVE
        </Typography>
      </Grid>

      <Grid
        container
        item
        style={{ flex: 1 }}
        alignItems="center"
        justify="flex-end"
      >
        <img
          src={asu_logo}
          className={classes.applogo}
          alt="asu"
          width="auto"
          height="25px"
        />
      </Grid>
    </Grid>
  );
};

export default HeaderView;
